import type { ImgHTMLAttributes } from "react"

const TRIYOGA_LOGO_PATH = "/ty_logo.png"

export default function AppLogoIcon(props: ImgHTMLAttributes<HTMLImageElement>) {
  const { className, ...rest } = props
  return (
    <img
      src={TRIYOGA_LOGO_PATH}
      alt="TriYoga"
      className={className}
      {...rest}
    />
  )
}
